import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=5e461fac&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&id=5e461fac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e461fac",
  null
  
)

export default component.exports